import './footer.css'
import logo from '../assets/logoFooter.webp'
import logoPT from '../assets/logoFooter-pt.webp'
import logoMobile from '../assets/logoFooterMobile.webp'
import logoMobilePT from '../assets/logoFooterMobile-pt.webp'
import facebook from '../assets/icons/facebook.svg'
import instagram from '../assets/icons/instagram.svg'
import youtube from '../assets/icons/youtube.svg'
import linkedin from '../assets/icons/linkedin.svg'
import twitter from '../assets/icons/twitter_x.svg'
import tiktok from '../assets/icons/tiktok.svg'
import {Link} from "react-router-dom";
import i18n from '../i18n';
import React from "react";


export default function Footer(props) {
    const {language} = props;

    const handleSocialNetworkClick = (e, url) => {
        e.preventDefault();
        window.open(url, '_blank');
    };

    return (
        <>
        <section className="footer">
            <div className="footer-section-content pb-5">
                <div className="container">
                    <div className="top-footer">
                        <div className="row">
                            <div className="text-center col-md-3 col-12">

                                <img className="img-fluid d-none d-md-inline" src={language==="es"?logo:logoPT} alt="logo Sitio de tiendas"/>

                                <img className="img-fluid d-md-none d-inline" src={language==="es"?logoMobile:logoMobilePT} alt="logo Sitio de tiendas"/>


                                <p className="mt-5 text-center">
                                {i18n.t('footer.text')}
                                </p>
                            </div>

                            <div className="col-md-1 col-0"></div>

                                <div className="col-md-5 col-12 links">
                                    <div className="row">
                                    <div className="col-6" >
                                        <h4>{i18n.t('footer.title1')}</h4>
                                        <ul>
                                            <Link to="/quienes-somos"><li>{i18n.t('footer.link1')}</li></Link>
                                            <Link to="/prensa"><li>{i18n.t('footer.link2')}</li></Link>
                                            <Link to="/blog"><li>{i18n.t('footer.link13')}</li></Link>
                                            <Link to="/testimonios"><li>{i18n.t('footer.link3')}</li></Link>
                                            <Link to="/contacto"><li>{i18n.t('footer.link4')}</li></Link>
                                            <a href="" data-bs-toggle="modal" data-bs-target="#termsModal"><li>{i18n.t('footer.link5')}</li></a>
                                        </ul>
                                    </div>
                                    <div className="col-6">
                                        <h4>{i18n.t('footer.title2')}</h4>
                                        <ul>
                                            <Link to="/como-vender"><li>{i18n.t('footer.link6')}</li></Link>
                                            <Link to="/como-comprar"><li>{i18n.t('footer.link7')}</li></Link>
                                            <Link to="/preguntas-frecuentes"><li>{i18n.t('footer.link8')}</li></Link>
                                            <Link to="/precios"><li>{i18n.t('footer.link14')}</li></Link>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-2 col-6 links">
                                <h4>{i18n.t('footer.title3')}</h4>
                                <ul>
                                    <Link to="/negocios-disponibles/1"><li>App</li></Link>
                                    <Link to="/negocios-disponibles/2"><li>Blog</li></Link>
                                    <Link to="/negocios-disponibles/3"><li>Canal de Youtube</li></Link>
                                    <Link to="/negocios-disponibles/4"><li>{i18n.t('footer.link10')}</li></Link>
                                    <Link to="/negocios-disponibles/5"><li>{i18n.t('footer.link11')}</li></Link>
                                    <Link to="/negocios-disponibles/6"><li>{i18n.t('footer.link9')}</li></Link>
                                </ul>
                            </div>

                        </div>
                     </div>

                    <hr />

                    <div className="bottom-footer">
                        <div className="row">
                            <div className="d-none d-md-block col-md-6 derechos">
                                <p>Copyright (c) 2025 <br/>
                                    {i18n.t('footer.site')}
                                    {i18n.t('footer.rights')}
                                </p>
                                <p>
                                    <a href="" data-bs-toggle="modal" data-bs-target="#termsModal">{i18n.t('footer.link5')}</a>
                                </p>
                            </div>

                            {language==="es"?
                            <div className="col-12 col-md-6 redes">
                                <a target={"_blank"} href="https://m.facebook.com/Sitiodetiendas-108732127559319/?__tn__=C-R">
                                    <span>
                                        <object data={facebook} alt="logo facebook"/>
                                    </span>
                                </a>

                                <a target={"_blank"} href="https://www.instagram.com/sitiodetiendas/?hl=es">
                                    <span>
                                        <object data={instagram} alt="logo instagram"/>
                                    </span>
                                </a>

                                <a target={"_blank"} href="https://www.youtube.com/channel/UCeLWm6EKxgD4rr1x5pDS0Bw">
                                    <span>
                                        <object data={youtube} alt="logo youtube"/>
                                    </span>
                                </a>

                                <a target={"_blank"} href="https://www.linkedin.com/company/sitio-de-tiendas/?trk=similar-pages">
                                    <span>
                                        <object data={linkedin} alt="logo linkedin"/>
                                    </span>
                                </a>

                                <a target={"_blank"} href="https://x.com/SitioDeTiendas" style={{zIndex: 0}}>
                                    <span className='bg-white' style={{ zIndex: 0 }} >
                                        <object className='mx-auto d-block' data={twitter} type="image/svg+xml" alt="logo x" style={{zIndex: 0, width: '24px', pointerEvents: 'none' }}/>
                                    </span>
                                </a>

                                <span className='bg-white' style={{ zIndex: 0, display:'inline-block', alignItems: 'center', justifyContent:'center', cursor:'pointer' }} onClick={(e) => handleSocialNetworkClick(e, 'https://www.tiktok.com/@sitio.de.tiendas')} >
                                    <img className='mx-auto d-block' src={tiktok} alt="logo tiktok" style={{zIndex: 0, width: '30px', marginTop: '3px' }}/>
                                </span>
                            </div>
                            :
                            <div className="col-12 col-md-6 redes">
                                <a target={"_blank"} href="https://www.facebook.com/people/Seu-Pr%C3%B3ximo-Neg%C3%B3cio/100069411683385/">
                                    <span>
                                        <object data={facebook} alt="logo facebook"/>
                                    </span>
                                </a>
                                <a target={"_blank"} href="https://www.instagram.com/seuproximonegociodigital/">
                                    <span>
                                        <object data={instagram} alt="logo instagram"/>
                                    </span>
                                </a>
                            </div>
                            }

                            <div className="text-center col-12 d-md-none d-block derechos">
                                <p>Copyright (c) 2025 <br/>
                                    {i18n.t('footer.site')}
                                    {i18n.t('footer.rights')}
                                </p>
                                <p>
                                   <a href="" data-bs-toggle="modal" data-bs-target="#termsModal"><li>{i18n.t('footer.link5')}</li></a>
                                </p>
                            </div>

                        </div>

                    </div>

                </div>
            </div>

        </section>


            </>

    )
}
